export default __webpack_public_path__ + "static/media/js-logo.97893fdc.png";